import { render, staticRenderFns } from "./listTag.vue?vue&type=template&id=f3289d68&"
import script from "./listTag.vue?vue&type=script&lang=js&"
export * from "./listTag.vue?vue&type=script&lang=js&"
import style0 from "./listTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports